/** Stable derived key for the explicit Company → Team/Category → Person hierarchy. */
export function companyTeamKey(companyId, category) {
    return `${companyId}::${category}`;
}
export function contactTeamKey(contact) {
    return companyTeamKey(contact.companyId, contact.crmCategory);
}
export function sameCompanyTeam(a, b) {
    return contactTeamKey(a) === contactTeamKey(b);
}
export function deriveCompanyTeams(companies, contacts) {
    const companyById = new Map(companies.map(company => [company.id, company]));
    const map = new Map();
    for (const contact of contacts) {
        if (contact.archived)
            continue;
        const key = contactTeamKey(contact);
        const existing = map.get(key);
        if (existing) {
            existing.people++;
            continue;
        }
        map.set(key, { key, companyId: contact.companyId, companyName: companyById.get(contact.companyId)?.name || contact.companyName, category: contact.crmCategory, people: 1 });
    }
    return [...map.values()].sort((a, b) => a.companyName.localeCompare(b.companyName) || a.category.localeCompare(b.category));
}
